import { Fade } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { CUSTOMER_REQUEST } from '../../constants'

const SRInfo = ({ 
    open, setOpen, data
}) => {

    const { t } = useTranslation();
    const { customer_request, grower_label, asset_ids, season_id, task_ids } = data;
    return (
        <>
            <Fade in={open} unmountOnExit={true}>
                <tr className="table-dark fs-5" onDoubleClick={() => {setOpen(false)}}>
                    <td colSpan={7}>
                        <div className="my-3 p-3">
                            <p> {t("Grower label")}: {grower_label} </p>  
                            <p> {t("Season ID")}: {season_id} </p>  
                            <p> {t("Asset IDs")}: {asset_ids} </p>  
                            { 
                                (customer_request !== CUSTOMER_REQUEST.PDF_REQUEST) && 
                                <p> {t("Task IDs")}: {task_ids} </p>
                            }
                        </div>
                    </td>
                </tr>
            </Fade>
        </>
    )
}

export default SRInfo